import React, { useState } from "react";
import { NECTAR_URL } from "../lib/constants";
import { getUrl } from "../lib/utils";
import { Button } from "../components/ui/button";
import { MessagesSquareIcon, PlayIcon, Users2, Users2Icon } from "lucide-react";

const FeatureCard = ({ label, icon }) => {
  return (
    <div className="flex gap-3 items-center">
      <div className="size-14 rounded-2xl bg-primary-900 flex items-center justify-center text-primary">
        {icon}
      </div>
      <p className="text-lg font-medium">{label}</p>
    </div>
  );
};

const CharacterCard = ({ name, age, image, link }) => {
  return (
    <a href={getUrl(link)}>
      <div className="w-full aspect-[9/12] bg-background-400 rounded-2xl overflow-hidden relative group">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-all duration-300"
        />

        <div className="absolute inset-0 flex items-end p-4 bg-gradient-to-t from-black/50 to-transparent via-transparent">
          <p className="text-white text-lg font-bold">
            {name} <span className="text-foreground/70">{age}</span>
          </p>
        </div>
      </div>
    </a>
  );
};

const NcJennyPage = () => {
  const handleStartChatting = () => {
    const redirectURL = getUrl(NECTAR_URL + "/discover");
    window.location.href = redirectURL;
  };

  return (
    <div className="pb-12">
      {/* header */}
      <div className="h-[60px] border-b">
        <div className="flex items-center gap-2 container justify-center h-full">
          <img
            src={"/assets/heart_logo.png"}
            alt="heart logo icon"
            className="size-8"
          />
          <h1 className="text-xl font-bold">Nectar AI</h1>
        </div>
      </div>

      {/* hero */}
      <div className="lg:jenny-container lg:grid grid-cols-2 lg:mt-8">
        <a href={getUrl(NECTAR_URL)}>
          <img
            src="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/648a8cf7-81f3-4c17-8d53-ae3b09079100/public"
            className="w-full aspect-[1/1] object-cover object-center lg:rounded-3xl"
          />
        </a>

        <div className="lg:flex justify-center items-center lg:p-8 mt-6 lg:mt-0 jenny-container">
          <div>
            <img
              src={"/assets/heart_logo.png"}
              alt="heart logo icon"
              className="size-16 hidden lg:block"
            />

            <h1 className="text-3xl lg:text-5xl/tight font-bold lg:mt-3 text-center lg:text-left">
              Chat with <br />
              <span className="text-primary">AI Sex Friend</span>
            </h1>

            <p className="text-lg mt-4 text-foreground-700 font-bold text-center lg:text-left">
              The Best AI Sex Chat
            </p>

            <Button
              onClick={handleStartChatting}
              className="mt-6 w-full bg-gradient-to-r from-primary h-12 font-bold"
            >
              Start Chatting
            </Button>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="jenny-container lg:flex gap-4 mt-6 lg:mt-16 space-y-4 lg:space-y-0 items-center lg:justify-around">
        <FeatureCard label="Fully Uncensored Content" icon={<Users2Icon />} />
        <FeatureCard
          label="Unlimited Spicy Chat"
          icon={<MessagesSquareIcon />}
        />
        <FeatureCard label="Hot Role Plays" icon={<PlayIcon />} />
      </div>

      {/* Character cards */}
      <div className="jenny-container mt-6 lg:mt-12">
        <h2 className="text-3xl font-bold text-center">
          <span className="text-primary">AI Sex Girls</span> to Chat With
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 mt-6 gap-6">
          <CharacterCard
            name="Eunji"
            age="21"
            image="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/1d4c5acf-2933-4033-cf54-80aaf21dcb00/public"
            link="https://nectar.ai/discover?type=companions&companion=f878bb8e-1ac7-4aa6-b672-92a3389f58b5"
          />

          <CharacterCard
            name="Eliza"
            age="19"
            image="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/ae03d7c4-8902-4cd8-dd00-59f08b426a00/public"
            link="https://nectar.ai/discover?type=companions&companion=79cdba12-dacd-4975-809a-2ed2c4a8ba51"
          />

          <CharacterCard
            name="Daniela"
            age="24"
            image="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/b1961a0d-12ca-4ee8-3880-2ce5499d7400/public"
            link="https://nectar.ai/discover?type=companions&companion=c637fa04-61d5-489d-88b1-4c9dda25e398"
          />

          <CharacterCard
            name="Katie"
            age="19"
            image="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/2925560e-274e-4d41-dff2-822561313d00/public"
            link="https://nectar.ai/discover?type=companions&companion=a5d0f3b4-2224-41f6-a41f-7709503aab1b"
          />
        </div>
      </div>

      {/* Footer */}
      <div className="jenny-container mt-8 lg:mt-16">
        <div className="w-full  bg-gradient-to-r from-background-400 rounded-2xl grid lg:grid-cols-2 lg:gap-4">
          <div className="p-14 pb-0 lg:pb-14">
            <h1 className="text-3xl/tight lg:text-4xl/tight font-bold text-center lg:text-left">
              Chat with <br />
              <span className="text-primary">AI Sex Friend</span>
            </h1>

            <p className="text-lg mt-4 text-foreground-700 font-bold text-center lg:text-left">
              The Best AI Sex Chat
            </p>

            <Button
              onClick={handleStartChatting}
              className="mt-8 px-12 bg-gradient-to-r from-primary h-12 w-full lg:w-auto font-bold"
            >
              Start Chatting
            </Button>
          </div>

          <div className="w-full  h-full relative overflow-hidden">
            <img
              src="https://imagedelivery.net/E9jTnsG9warNlQK5dUFRKA/378591a5-0964-496f-db16-0e7f561efd00/public"
              className="w-full h-full object-cover object-center lg:absolute inset-0 scale-110"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NcJennyPage;
